import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-home',
  templateUrl: './campaign-home.component.html',
  styleUrls: ['./campaign-home.component.scss']
})
export class CampaignHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
